import React from 'react';
import { func, object, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { injectReducer, injectSaga } from 'utils/store';
import {
  actions as surchargesActions,
  saga as surchargesSaga,
  selectors as surchargesSelectors,
  PATH as SURCHG_PATH,
} from './Surcharges';
import { reducer } from './state';
import { PATH } from './const';

const withPayment = (Component) => {
  const WithPayment = (props) => {
    const { surcharges, getSurcharge, surchargeFetchingStatus } = props;

    const payment = {
      surcharges,
      getSurcharge,
      surchargeFetchingStatus,
    };

    return <Component payment={payment} {...props} />;
  };

  WithPayment.propTypes = {
    surcharges: object,
    surchargeFetchingStatus: string,
    getSurcharge: func,
  };

  // Wrap display name (helps debug)
  WithPayment.displayName = `WithPayment(${
    Component.displayName || Component.name || 'Component'
  })`;

  const mapStateToProps = (state) => ({
    surcharges: surchargesSelectors.getResults(state),
    surchargeFetchingStatus: surchargesSelectors.getSurchargeFetchingStatus(
      state,
    ),
  });

  const mapDispatchToProps = {
    getSurcharge: surchargesActions.request,
  };

  return compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectReducer({ key: PATH, reducer }),
    injectSaga({ key: SURCHG_PATH, saga: surchargesSaga }),
    withImmutablePropsToJS,
  )(WithPayment);
};

export default withPayment;
